module.exports = __webpack_public_path__ + "static/logo-pam-panorama-2-caccb6f12ee352d6d8cabe1b9f6ac8fc.png";